module.exports = __webpack_public_path__ + "static/media/video_placeholder_mobile.dfbde65f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_placeholder_mobile.jpg
// module id = 57
// module chunks = 0